import { render } from "./ConfigAppVersion.vue?vue&type=template&id=3601c6ba&scoped=true"
import script from "./ConfigAppVersion.vue?vue&type=script&lang=js"
export * from "./ConfigAppVersion.vue?vue&type=script&lang=js"

import "./ConfigAppVersion.vue?vue&type=style&index=0&id=3601c6ba&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3601c6ba"]])

export default __exports__